<template>
  <div class="item-application__media">
    <div class="media-img__title-wrap">
      <p class="text-TTDrugs-bold-24 color-green">Центр изнутри</p>
    </div>
    <div class="media-img media-grid-3">
      <div
          class="media-img__wrap"
          v-for="(img, index) in images"
          :key="index"
      >
        <img
            :src="img.thumb"
            :alt="img.alt"
            class="media-img__img"
            @click="openGallery(index)"
        />
      </div>
    </div>
    <LightBox
        ref="lightbox"
        :media="images"
        :show-light-box="lightboxVisible"
        :site-loading="siteLoading"
        @close="closeLightbox"
    />
  </div>
</template>

<script>
  import LightBox from "vue-image-lightbox";
  import siteLoading from "../../assets/img/siteloading.gif";
  import 'vue-image-lightbox/dist/vue-image-lightbox.min.css';

  export default {
    name: 'AppSwiperGallery',
    components: {
      LightBox,
    },
    data() {
      return {
        siteLoading,
        images: [
          { src: require('../../assets/img/gallery-center/1.jpg'), thumb: require('../../assets/img/gallery-center/1.jpg'), alt: 'Image 1', caption: 'Описание изображения 1' },
          { src: require('../../assets/img/gallery-center/2.jpg'), thumb: require('../../assets/img/gallery-center/2.jpg'), alt: 'Image 2', caption: 'Описание изображения 2' },
          { src: require('../../assets/img/gallery-center/3.jpg'), thumb: require('../../assets/img/gallery-center/3.jpg'), alt: 'Image 3', caption: 'Описание изображения 3' },
          { src: require('../../assets/img/gallery-center/4.jpg'), thumb: require('../../assets/img/gallery-center/4.jpg'), alt: 'Image 4', caption: 'Описание изображения 4' },
          { src: require('../../assets/img/gallery-center/5.jpg'), thumb: require('../../assets/img/gallery-center/5.jpg'), alt: 'Image 5', caption: 'Описание изображения 5' },
          { src: require('../../assets/img/gallery-center/6.jpg'), thumb: require('../../assets/img/gallery-center/6.jpg'), alt: 'Image 6', caption: 'Описание изображения 6' },
          { src: require('../../assets/img/gallery-center/7.jpg'), thumb: require('../../assets/img/gallery-center/7.jpg'), alt: 'Image 7', caption: 'Описание изображения 7' },
          { src: require('../../assets/img/gallery-center/8.jpg'), thumb: require('../../assets/img/gallery-center/8.jpg'), alt: 'Image 8', caption: 'Описание изображения 8' },

        ],
        lightboxVisible: false,
        currentImage: null
      };
    },
    methods: {
      openGallery(index) {
        this.$refs.lightbox.showImage(index);
        this.lightboxVisible = true;
      },
      closeLightbox() {
        this.lightboxVisible = false;
      }
    }
  };
</script>

<style>

</style>
